import { useLoader } from "@react-three/fiber";
import { useMemo } from "react";
import * as THREE from "three";
import { SVGLoader } from "three/examples/jsm/loaders/SVGLoader.js";
import { COURT_DIMENSIONS } from "./courtConstants";

const LogoMesh = () => {
	const svgData = useLoader(SVGLoader, "/img/heatmap/logo3d.svg");

	const extrudeSettings = useMemo(
		() => ({
			steps: 1,
			depth: 0.1,
			bevelEnabled: false,
		}),
		[],
	);

	const shapesWithColor = useMemo(
		() =>
			svgData.paths.flatMap((path) => {
				const shapes = SVGLoader.createShapes(path);
				return shapes.map((shape) => ({ shape, color: path.color }));
			}),
		[svgData],
	);

	const geometries = useMemo(
		() =>
			shapesWithColor.map(
				(sc) => new THREE.ExtrudeGeometry(sc.shape, extrudeSettings),
			),
		[shapesWithColor, extrudeSettings],
	);

	const centerOffset = useMemo(() => {
		const tempGroup = new THREE.Group();
		geometries.forEach((geometry) => {
			tempGroup.add(new THREE.Mesh(geometry));
		});
		const box = new THREE.Box3().setFromObject(tempGroup);
		const center = new THREE.Vector3();
		box.getCenter(center);
		return center;
	}, [geometries]);

	return (
		<group
			position={[0, 0.3, COURT_DIMENSIONS.HEIGHT / 2 - 1.4]} // Place it at the bottom-center
			rotation={[-Math.PI / 2, Math.PI, -Math.PI]} // Rotated to face camera
			scale={0.056}
		>
			<group position={[-centerOffset.x, -centerOffset.y, 0]}>
				{shapesWithColor.map(({ color }, index) => {
					return (
						<mesh key={index} geometry={geometries[index]}>
							<meshBasicMaterial color={color} side={THREE.DoubleSide} />
						</mesh>
					);
				})}
			</group>
		</group>
	);
};

export default LogoMesh;
